import React from 'react';

import _ from 'lodash';

import FieldGroup from '../../Fields/FieldGroup';
import Field from '../../Fields/Field';
import InputTextField from '../../Fields/InputTextField';


class SettingsTermsPanel extends React.Component {
  _onInputChange(inputId) {
    return value => {
      this.props.onValueChange(inputId, value);
    };
  }


  render() {
    const {
      editMode,
      settings
    } = this.props;

    return (
      <div>
        <FieldGroup label="Terms &amp; Conditions">
          <Field label="Next Steps After Sign Up"
            id="parkchirp--settings--next-steps"
            layout="stacked">
            <InputTextField inputId="parkchirp--settings--next-steps"
              value={settings.fields.next_steps.value}
              onChange={this._onInputChange('next_steps')}
              editMode={editMode}
              multiLine={true}
            />
          </Field>
          <Field label="Terms &amp; Conditions"
            id="parkchirp--settings--terms-and-conditions"
            layout="stacked">
            <InputTextField inputId="parkchirp--settings--terms-and-conditions"
              value={settings.fields.terms_and_conditions.value}
              onChange={this._onInputChange('terms_and_conditions')}
              editMode={editMode}
              multiLine={true}
            />
          </Field>
          <Field label="Terms &amp; Conditions (Summary)"
            id="parkchirp--settings--terms-and-conditions-summary"
            layout="stacked">
            <InputTextField inputId="parkchirp--settings--terms-and-conditions-summary"
              value={settings.fields.terms_and_conditions_summary.value}
              onChange={this._onInputChange('terms_and_conditions_summary')}
              editMode={editMode}
              multiLine={true}
            />
          </Field>
        </FieldGroup>
      </div>
    );
  }
}
export default SettingsTermsPanel;
